import { M8PartnerBalance } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

export async function getPartnerBalance(): Promise<null | M8PartnerBalance> {
  const url = getM8PartnerURL('getPartnerBalance');

  const response = await fetch(url);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
}
